<template>
  <Newsletter
    :title="title"
    :subtitle="subTitle"
    class="container unpadded"
    :sending="loading"
    :done="done"
    :subscription-result="subscriptionResult"
    @submitEmail="onSubmitEmail"
    @validationError="onValidationError"
  ></Newsletter>
</template>
<script>
import { Newsletter } from '@article/pixel';
import useNewsletter from '@/compositions/useNewsletter.js';

import Tracking from '@/components/commons/Tracking.js';

export default {
  components: {
    Newsletter,
  },
  props: {
    title: {
      type: String,
      default: `New products, sweet savings — straight to your inbox.`,
    },
    subTitle: String,
  },
  setup() {
    const {
      subscribeUserEmail, //
      subscriptionResult,
      loading,
      called,
      done,
    } = useNewsletter();

    return {
      subscribeUserEmail,
      subscriptionResult,
      loading,
      called,
      done,
    };
  },
  methods: {
    onValidationError() {
      this.done = false;
    },
    onSubmitEmail(email) {
      if (!this.called) {
        this.subscribeUserEmail({ email, subscriptionSource: 'Newsletter' });
        Tracking.heapIdentifyEmail(email);
      }
    },
  },
};
</script>
